import type { CountdownTimerComponent as CountdownTimerComponentType } from '../../schemas/validation';

export interface CountdownTimerComponentProps {
  component: CountdownTimerComponentType;
  isEditing?: boolean;
}

export interface TimeRemaining {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  total: number;
}

export const INITIAL_TIME: TimeRemaining = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  total: 0,
};

export type Alignment = 'left' | 'center' | 'right';
export type Size = 'small' | 'medium' | 'large';
export type Layout = 'horizontal' | 'vertical' | 'grid';
export type NumberStyle = 'default' | 'bold' | 'card' | 'gradient';
export type SeparatorStyle = 'colon' | 'slash' | 'dot' | 'none';
export type DisplayFormat = 'full' | 'compact' | 'minimal';
